<template>
  <v-autocomplete
    v-model="selectedItems"
    :items="items"
    item-text="name"
    item-value="id"
    multiple
    return-object
  >
    <template v-slot:selection="{ item }">
      <v-chip>
        <v-icon>{{ item.icon }}</v-icon>
        <span>{{ item.name }}</span>
        <span>{{ item.text }}</span>
      </v-chip>
    </template>
    <template v-slot:item="{ item }">
      <div class="d-flex align-center">
        <v-icon>{{ item.icon }}</v-icon>
        <span>{{ item.name }}</span>
        <v-text-field v-model="item.text" label="hakdog"></v-text-field>
      </div>
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  data() {
    return {
      selectedItems: [],
      items: [
        { id: 1, name: 'Item 1', icon: 'mdi-account', text: '' },
        { id: 2, name: 'Item 2', icon: 'mdi-email', text: '' },
        { id: 3, name: 'Item 3', icon: 'mdi-lock', text: '' },
      ],
    };
  },
};
</script>